const LABELS = { cash: "Cash", zelle: "Zelle", venmo: "Venmo", stripe: "Card" };

export function PaymentBadges({ methods, className = "" }) {
  const list = (methods || []).filter((m) => LABELS[m]);
  if (!list.length) return null;
  return (
    <div className={`flex flex-wrap gap-1 ${className}`} data-testid="payment-badges">
      {list.map((m) => (
        <span
          key={m}
          className="text-[10px] uppercase tracking-wide font-semibold px-1.5 py-0.5 rounded-sm bg-muted text-muted-foreground border border-border"
          data-testid={`pay-badge-${m}`}
        >
          {LABELS[m]}
        </span>
      ))}
    </div>
  );
}
